import { getJson } from "../api_helpers";
import { classifyApiError, expireSession } from "./apiError";

export function pingBackend() {
  return function(dispatch) {
    return getJson(Routes.api_pings_path()).then (
      response => {
        if (response.status === 200) return
        if (classifyApiError(response.status) === 'session') {
          dispatch(expireSession())
        }
      }
    )
  }
}
